/* yl-cart-drawer-more.js — "下面还有 N 款商品 ↓" hint for the cart drawer (2026-11-02).
   User report: with 11 lines only 3 showed on a phone and the third ended exactly at the list edge, so the cart
   looked complete; the existing 44px bottom fade was too subtle to read as "scroll for more".
   The drawer re-renders its whole inner HTML after every quantity change (yololife-cart-drawer.js replaceCart),
   so this script never caches nodes: it listens on the dialog (scroll in the capture phase, a MutationObserver
   for re-renders, resize) and looks the list up each time. */
(function () {
  'use strict';
  var dialog = document.querySelector('[data-yl-cart-drawer]');
  if (!dialog) return;

  var frame = 0;

  function label(count) {
    var template = count === 1 ? dialog.dataset.moreOne : dialog.dataset.moreOther;
    return String(template || '').replace('%count%', String(count));
  }

  function update() {
    frame = 0;
    var list = dialog.querySelector('[data-yl-cart-drawer-items]');
    var hint = dialog.querySelector('[data-yl-cart-drawer-more]');
    if (!list || !hint) return;
    var bottom = list.getBoundingClientRect().bottom;
    // Lines not fully visible below the fold (a sliver of the next line counts as hidden).
    var hidden = Array.prototype.filter.call(list.querySelectorAll('[data-yl-cart-drawer-line]'), function (line) {
      return line.getBoundingClientRect().bottom > bottom + 4;
    }).length;
    var show = dialog.open && hidden > 0;
    if (show) {
      var text = label(hidden);
      var span = hint.querySelector('[data-yl-cart-drawer-more-label]');
      if (span && span.textContent !== text) span.textContent = text;
    }
    if (hint.hidden === show) hint.hidden = !show;
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  dialog.addEventListener('scroll', schedule, true);
  window.addEventListener('resize', schedule, { passive: true });
  new MutationObserver(schedule).observe(dialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });

  dialog.addEventListener('click', function (event) {
    var hint = event.target.closest('[data-yl-cart-drawer-more]');
    if (!hint) return;
    var list = dialog.querySelector('[data-yl-cart-drawer-items]');
    if (!list) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.scrollBy({ top: Math.max(120, list.clientHeight * 0.75), behavior: reduce ? 'auto' : 'smooth' });
  });

  schedule();
})();
